import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'equipmentIcon',
  standalone: true,
  pure: true,
})
export class EquipmentIconPipe implements PipeTransform {

  private readonly iconMap = new Map<string, string>([
    ['conductor', 'id_card'],
    ['camion', 'local_shipping'],
    ['grua', 'forklift'],
  ]);

  transform(type: string | null | undefined): string {
    if (!type) return 'close';

    const normalizedType = this.normalizeString(type);
    return this.iconMap.get(normalizedType) || 'close';
  }

  private normalizeString(str: string): string {
    return str
      .normalize('NFD') // Separa caracteres y diacríticos (tildes)
      .replace(/[\u0300-\u036f]/g, '') // Elimina diacríticos
      .toLowerCase()     // Convierte a minúsculas
      .replace(/\s+/g, '_');  // Reemplaza espacios por guiones bajos
  }

}
